export const TABLE_ACTION_COLUMN_WIDTH = 120
export const TABLE_ACTION_CELL_CLASSNAME = "flex flex-nowrap items-center justify-center gap-x-1"

export const PAGINATION_CONFIG = {
  showQuickJumper: true,
  showSizeChanger: true,
  hideOnSinglePage: false,
  pageSizeOptions: ["10", "20", "50", "100"],
  showTotal: (total: number, range: number[]) => `Hiển thị mục ${range[0]}-${range[1]} / trong tổng số ${total} mục`,
}

export const PAGE_CONFIG = {
  page: 1,
  per_page: 20,
}
